const formatToCurrencyBrl = (value?: string) => {
  if (!value) {
    value = Math.floor(0).toLocaleString('pt-br', { minimumFractionDigits: 2 })
  }

  return parseFloat(value).toLocaleString('pt-br', { minimumFractionDigits: 2 })
}

export default formatToCurrencyBrl
